/**
 * The glyph each money row carries, on Billing's recent rows and on Transactions.
 *
 * Read from `ledger_entry.kind` (and, for a card top-up, whether auto-reload made it), so the two
 * screens cannot draw the same row two ways. The prototype's glyphs where it has the kind
 * (WeTalk.dc.html, `txn.all`); a kind the console does not know is a plain receipt.
 */
import type { PhosphorIcon } from "@wetalk/ui";

import { GLYPH } from "../../shell/glyph.js";
import type { LedgerEntryView } from "../../api/gateway.js";
import { confirmationCodeLedgerKindOf, isAutoReload, ledgerKindOf, planFeeLedgerKindOf } from "./billing-copy.js";

export function ledgerGlyphOf(row: LedgerEntryView): PhosphorIcon {
  // plan-020 WAPP-BILL: a plan fee's card payment and the fee itself (the plan card's lightning, as on the dashboard).
  const fee = planFeeLedgerKindOf(row.kind);
  if (fee !== null) return fee === "subscription_payment" ? GLYPH.creditCard : GLYPH.lightning;
  // plan-029 STMT-CODE: a confirmation code sent by text message to confirm who's calling.
  if (confirmationCodeLedgerKindOf(row.kind) !== null) return GLYPH.shieldCheck;
  const kind = ledgerKindOf(row.kind);
  switch (kind) {
    case "talk_charge":
      return GLYPH.phoneCall;
    case "credit_purchase":
      return isAutoReload(row.description) ? GLYPH.arrowsClockwise : GLYPH.plusCircle;
    case "refund":
      return GLYPH.arrowUDownLeft;
    case "review_charge":
      return GLYPH.sparkle;
    case "adjustment":
      return GLYPH.pencilSimple;
    case "trial_grant":
      return GLYPH.gift;
    case "number_charge":
    case null:
      return GLYPH.receipt;
  }
}
